<!-- Alerta warning denuncia estado fallido -->
<ng-container *ngIf="!(loading$ | async) && accidentEstadoFallido">
  <div class="errorEstadoFallidoContainer">
    <div class="alert alert-danger">
      <label>{{ errorEstadoFallido }}</label>
    </div>
  </div>
</ng-container>

<!-- Alerta warning adjuntos estado fallido -->
<ng-container
  *ngIf="!(loading$ | async) && accidentAttachmentsEstadoFallido"
>
  <div class="errorEstadoFallidoContainer">
    <div class="alert alert-danger">
      <label>{{ errorEstadoAdjuntosFallido }}</label>
    </div>
  </div>
</ng-container>

<!-- Tabs header -->
<div class="tab-header">
  <span
    (click)="activeTab = tabs.DATA_ACCIDENT"
    [class.active]="activeTab == tabs.DATA_ACCIDENT"
    >Datos del siniestro</span
  >
  <span
    (click)="activeTab = tabs.DATA_POLICY"
    [class.active]="activeTab == tabs.DATA_POLICY"
    >Datos de la póliza</span
  >
  <span
    (click)="activeTab = tabs.DATA_CLAIM"
    [class.active]="activeTab == tabs.DATA_CLAIM"
    >Datos del accidente</span
  >
  <span
    (click)="activeTab = tabs.DATA_IMAGES"
    [class.active]="activeTab == tabs.DATA_IMAGES"
    >Archivos adjuntos</span
  >
  <span
    *ngIf="hasClaimants"
    (click)="activeTab = tabs.DATA_CLAIMANTS"
    [class.active]="activeTab == tabs.DATA_CLAIMANTS"
    ><i
      [class.fa-exclamation-circle]="!!submitClaimantsSAPFailed"
      [class.fa-exclamation-triangle]="!!submitClaimantsSAPWaiting"
      class="claimants-fail-icon fas"
    ></i
    >Reclamantes</span
  >
</div>

<!-- Tabs content -->

<div class="tab-container">
  <app-prime-loader *ngIf="loading$ | async"></app-prime-loader>
  <div class="container" *ngIf="!(loading$ | async)">
    <ng-container *ngIf="activeTab == tabs.DATA_ACCIDENT"
      ><sbi-cot-back-accident-data-tab
        [tabAction]="tabAction"
        [puedeEditarMatriculaYChasis]="puedeEditarMatriculaYChasis"
        [puedeEditarFechaHoraOcurrencia]="puedeEditarFechaHoraOcurrencia"
        [attemptedReprocess]="attemptedReprocess"
        (editAccidentTabData)="editAccidentTabData($event)"
      ></sbi-cot-back-accident-data-tab
    ></ng-container>
    <ng-container *ngIf="activeTab == tabs.DATA_POLICY">
      <sbi-cot-back-policy-data-tab></sbi-cot-back-policy-data-tab>
    </ng-container>
    <ng-container *ngIf="activeTab == tabs.DATA_CLAIM">
      <sbi-cot-back-claim-data-tab></sbi-cot-back-claim-data-tab>
    </ng-container>
    <ng-container *ngIf="activeTab == tabs.DATA_IMAGES">
      <sbi-cot-back-images-data-tab></sbi-cot-back-images-data-tab>
    </ng-container>
    <ng-container *ngIf="activeTab == tabs.DATA_CLAIMANTS">
      <sbi-cot-back-claimants-data-tab
        [tabAction]="tabAction"
      ></sbi-cot-back-claimants-data-tab>
    </ng-container>
  </div>
</div>
